import { Component, Input, OnInit } from '@angular/core';
import { Acesso } from "../../../../core/acesso";
import { ComboIdDescricao } from '../../../../core/combo-publico-alvo';
import { PlanejamentoOficina } from '../../../../core/planejamento-oficina';
import { PublicoAlvoPlanejamentoOficina } from '../../../../core/publico-alvo-planejamento-oficina';
import { DataUtilService } from "../../../../services/commons/data-util.service";
import { PublicoAlvoService } from '../../../../services/publico-alvo/publico-alvo.service';
import { ToastService } from '../../../../services/toast/toast.service';

@Component({
    selector: 'cadastrar-publico-alvo-planejamento-oficina',
    templateUrl: './cadastrar-publico-alvo-planejamento-oficina.component.html',
    styleUrls: ['./cadastrar-publico-alvo-planejamento-oficina.component.css']
})
export class CadastrarPublicoAlvoPlanejamentoOficinaComponent implements OnInit {

    @Input() perfilAcesso: Acesso;

    @Input() planejamentoOficina: PlanejamentoOficina;
    publicoAlvo: PublicoAlvoPlanejamentoOficina = new PublicoAlvoPlanejamentoOficina();

    isAtualizar = false;

    constructor(private toastService: ToastService,
        private dataUtilService: DataUtilService, 
        private publicoAlvoService: PublicoAlvoService) {
    }

    ngOnInit() {
        this.zerarCombos();
    }

    zerarCombos() {
        this.publicoAlvo = new PublicoAlvoPlanejamentoOficina();
    }

    adicionar() {
        const publicoAlvoPlanejamentoOficina = new PublicoAlvoPlanejamentoOficina();
        publicoAlvoPlanejamentoOficina.idPublicoAlvo = this.publicoAlvo.id;
        publicoAlvoPlanejamentoOficina.descricao = this.publicoAlvo.descricao;
        publicoAlvoPlanejamentoOficina.idPlanejamentoOficina = this.planejamentoOficina.id;

        if (!this.planejamentoOficina.publicosAlvosPlanejamentoOficina) {
            this.planejamentoOficina.publicosAlvosPlanejamentoOficina = [];
        }

        if (this.planejamentoOficina.publicosAlvosPlanejamentoOficina.some(pa => 
            pa.idPublicoAlvo === publicoAlvoPlanejamentoOficina.idPublicoAlvo && pa.idPlanejamentoOficina === publicoAlvoPlanejamentoOficina.idPlanejamentoOficina)) {
            this.toastService.showAlerta('Este público-alvo já foi adicionado para este planejamento de oficina.');
            return;
        }

        this.planejamentoOficina.publicosAlvosPlanejamentoOficina.push(publicoAlvoPlanejamentoOficina);
        this.zerarCombos();
    }

    atualizar() {
        const index = this.planejamentoOficina.publicosAlvosPlanejamentoOficina.indexOf(
            this.planejamentoOficina.publicosAlvosPlanejamentoOficina.find(col => col.id === this.publicoAlvo.id));

        this.planejamentoOficina.publicosAlvosPlanejamentoOficina.splice(index, 1, this.publicoAlvo);

        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarPublicoAlvoPlanejamentoOficina(publicoAlvoPlanejamentoOficina: PublicoAlvoPlanejamentoOficina) {
        this.isAtualizar = true;
        this.publicoAlvo = publicoAlvoPlanejamentoOficina;
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onDescricaoChangePublicoAlvo(event: ComboIdDescricao) {
        if (event) {
            this.carregarPublicoAlvo(event);
        } else {
            this.publicoAlvo = undefined;
        }
    }

    carregarPublicoAlvo(comboPublicoAlvoPlanejamentoOficina: ComboIdDescricao) {
        this.publicoAlvoService.getPublicoAlvoById(comboPublicoAlvoPlanejamentoOficina.id).subscribe((publicoAlvo: PublicoAlvoPlanejamentoOficina) => {
            this.publicoAlvo = publicoAlvo;
        })
    }
}
